import api from '../../../../api/client';

export const PAY_HEAD_OPTIONS = [
  { value: 'None', label: 'None' },
  { value: 'Salary Advance', label: 'Salary Advance' },
  { value: 'Personal Loan', label: 'Personal Loan' },
  { value: 'Emergency Loan', label: 'Emergency Loan' },
  { value: 'Festival Advance', label: 'Festival Advance' },
  { value: 'Medical Advance', label: 'Medical Advance' },
  { value: 'Vehicle Loan', label: 'Vehicle Loan' },
  { value: 'Equipment Loan', label: 'Equipment Loan' },
  { value: 'Loan EMI Recovery', label: 'Loan EMI Recovery' },
];

export const LOAN_TYPE_OPTIONS = [
  { value: 'Personal Loan', label: 'Personal Loan' },
  { value: 'Home Renovation & Repairs', label: 'Home Renovation & Repairs' },
  { value: 'Vehicle Purchase Loan', label: 'Vehicle Purchase Loan' },
  { value: 'Higher Education Tuition', label: 'Higher Education Tuition' },
  { value: 'Medical Emergency Relief', label: 'Medical Emergency Relief' },
  { value: 'Festival & Travel Advance', label: 'Festival & Travel Advance' },
  { value: 'Salary Advance', label: 'Salary Advance' },
];

export const EMPLOYEE_OPTIONS = [
  { value: 'System Admin', label: 'System Admin (USR-0001) - IT' },
  { value: 'Rolex', label: 'Rolex (USR-0002) - Operations' },
  { value: 'Shubham', label: 'Shubham (USR-0003) - Engineering' },
  { value: 'Test2', label: 'Test2 (USR-0004) - Product' },
  { value: 'test3', label: 'test3 (USR-0005) - Finance' },
];

export const STATUS_OPTIONS = [
  { value: 'All', label: 'All Status' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
];

function formatDateDisplay(dtStr) {
  if (!dtStr) return '';
  const d = new Date(dtStr);
  if (isNaN(d.getTime())) return dtStr;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

function mapBackendToFrontend(item) {
  if (!item) return null;
  return {
    id: item.id || item.ID,
    name: item.emp_name || item.employee_name || `Employee #${item.emp_id || item.EmpId}`,
    employeeId: `EMP-${item.emp_id || item.EmpId}`,
    emp_id: item.emp_id || item.EmpId,
    applyDate: item.apply_date ? String(item.apply_date).split('T')[0] : (item.ApplyDate ? String(item.ApplyDate).split('T')[0] : ''),
    applyDateDisplay: formatDateDisplay(item.apply_date || item.ApplyDate),
    payHead: item.pay_head_name || 'Loan EMI Recovery',
    pay_head_id: item.pay_head_id || item.PayHeadID,
    loanDate: item.loan_date ? String(item.loan_date).split('T')[0] : (item.LoanDate ? String(item.LoanDate).split('T')[0] : ''),
    loanDateDisplay: formatDateDisplay(item.loan_date || item.LoanDate),
    loanType: item.reason_name || item.loan_type_name || 'Personal Loan',
    loan_type: item.loan_type || item.LoanType,
    loanAmount: Number(item.loan_amt || item.LoanAmt || 0),
    guarantorName1: item.guarantor_name_1 || item.GuarantorName1 || item.guarantor1_name || '',
    guarantorName2: item.guarantor_name_2 || item.GuarantorName2 || item.guarantor2_name || '',
    guarantor1_id: item.guarantor_1_id || item.Guarantor1ID || null,
    guarantor2_id: item.guarantor_2_id || item.Guarantor2ID || null,
    emiFromDate: item.emi_from_date ? String(item.emi_from_date).split('T')[0] : (item.EMIFromDate ? String(item.EMIFromDate).split('T')[0] : ''),
    emiAmount: Number(item.emi_amt || item.EMIAmt || 0),
    reason: item.reason_name || item.loan_type_name || 'Personal Loan',
    remarks: item.remarks || item.Remarks || '',
    status: item.status || (item.is_approved === 1 ? 'Approved' : (item.is_approved === 2 ? 'Rejected' : 'Pending')),
    company: 'All',
    branch: 'All',
    department: 'All',
    createdDate: formatDateDisplay(item.loan_date || item.apply_date || item.LoanDate || item.ApplyDate),
  };
}

export const loansApi = {
  getOptions: async () => {
    try {
      const { data } = await api.get('/payroll/emp-loans/options');
      return data;
    } catch (err) {
      console.error('Failed to load loans options from API', err);
      return null;
    }
  },

  getLoans: async (filters = {}) => {
    const params = {
      search: filters.name || undefined,
      approved: filters.status && filters.status !== 'All' ? (filters.status === 'Approved' ? 1 : (filters.status === 'Rejected' ? 2 : 0)) : undefined,
      page: 1,
      page_size: 100,
    };
    const { data } = await api.get('/payroll/emp-loans/', { params });
    const items = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    let list = items.map(mapBackendToFrontend);

    if (filters.status && filters.status !== 'All') {
      list = list.filter((r) => r.status === filters.status);
    }
    return list;
  },

  getLoanById: async (id) => {
    const { data } = await api.get(`/payroll/emp-loans/${id}`);
    return mapBackendToFrontend(data);
  },

  createLoan: async (payload) => {
    const body = {
      emp_id: Number(payload.emp_id || payload.employeeId?.replace(/\D/g, '') || 1),
      pay_head_id: Number(payload.pay_head_id || 0),
      loan_date: payload.loanDate ? `${payload.loanDate}T00:00:00` : null,
      loan_amt: Number(payload.loanAmount || 0),
      emi_amt: Number(payload.emiAmount || 0),
      emi_from_date: payload.emiFromDate ? `${payload.emiFromDate}T00:00:00` : null,
      loan_type: Number(payload.loan_type || 1),
      apply_date: payload.applyDate ? `${payload.applyDate}T00:00:00` : null,
      remarks: payload.remarks || null,
      guarantor_1_id: payload.guarantor1_id ? Number(payload.guarantor1_id) : null,
      guarantor_2_id: payload.guarantor2_id ? Number(payload.guarantor2_id) : null,
      guarantor_name_1: payload.guarantorName1 || null,
      guarantor_name_2: payload.guarantorName2 || null,
    };
    const { data } = await api.post('/payroll/emp-loans/', body);
    return data;
  },

  updateLoan: async (id, payload) => {
    const body = {
      emp_id: Number(payload.emp_id || payload.employeeId?.replace(/\D/g, '') || 1),
      pay_head_id: Number(payload.pay_head_id || 0),
      loan_date: payload.loanDate ? `${payload.loanDate}T00:00:00` : null,
      loan_amt: Number(payload.loanAmount || 0),
      emi_amt: Number(payload.emiAmount || 0),
      emi_from_date: payload.emiFromDate ? `${payload.emiFromDate}T00:00:00` : null,
      loan_type: Number(payload.loan_type || 1),
      apply_date: payload.applyDate ? `${payload.applyDate}T00:00:00` : null,
      remarks: payload.remarks || null,
      guarantor_1_id: payload.guarantor1_id ? Number(payload.guarantor1_id) : null,
      guarantor_2_id: payload.guarantor2_id ? Number(payload.guarantor2_id) : null,
      guarantor_name_1: payload.guarantorName1 || null,
      guarantor_name_2: payload.guarantorName2 || null,
    };
    const { data } = await api.put(`/payroll/emp-loans/${id}`, body);
    return data;
  },

  updateLoanStatus: async (id, status) => {
    const is_approved = status === 'Approved' ? 1 : (status === 'Rejected' ? 2 : 0);
    const { data } = await api.patch(`/payroll/emp-loans/${id}/approve`, { is_approved });
    return data;
  },

  deleteLoan: async (id) => {
    const { data } = await api.post(`/payroll/emp-loans/${id}/delete`);
    return data;
  },

  getLoansReport: async (filters = {}) => {
    const params = {
      emp_id: filters.emp_id || undefined,
      status: filters.status && filters.status !== 'All' ? filters.status : undefined,
      search: filters.search || undefined,
    };
    const { data } = await api.get('/payroll/emp-loans/report', { params });
    return data;
  },
};

